
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import AuthShell, { AlertIcon } from './AuthShell';
import { history } from '../../history';
import { AlertAction, AuthAction } from '../../actions';
import { Translate as t } from '../../config/Translate';

const ForgotPassword = ({ AlertError }) => {
    const [email, setEmail] = useState("");
    const [errMsg, seterrMsg] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleEmailChange = (e) => {
        seterrMsg("")
        setEmail(e.target.value);
    }

    const handleSendEmailClick = (e) => {
        if (e && e.preventDefault) e.preventDefault(); // Enter 전송 시 페이지 새로고침 방지
        if (submitting) return;
        setSubmitting(true);
        AuthAction.RequestForgotPassword({ email }).then((ret) => {
            if (ret?.status == "success") {
                history.push("/ForgotPasswordSent");
            }
            else {
                setSubmitting(false);
                AlertError(ret?.errors);
                if (ret?.errors) {
                    if (ret.errors.type == "invalidEmail")
                        seterrMsg(t('auth.message.error.emailDoesNotExist'))
                }
            }
        }).catch(() => setSubmitting(false));
    }

    return (
        <AuthShell title={t('auth.button.forgotPassword')} description={t('auth.message.info.forgotPasswordDesc')}>
            <form onSubmit={handleSendEmailClick}>
                <div className={`rg-login-field${errMsg ? ' has-error' : ''}`}>
                    <label htmlFor="rg-forgot-email">{t('common.field.email')}</label>
                    <div className="rg-login-input-wrap">
                        <input id="rg-forgot-email" type="email"
                            value={email}
                            name="email" onChange={handleEmailChange}
                            aria-describedby="rg-forgot-email-err"
                            aria-invalid={!!errMsg} />
                    </div>
                    {errMsg && (
                        <span className="rg-login-err-msg" id="rg-forgot-email-err" role="alert">
                            <AlertIcon />{errMsg}
                        </span>
                    )}
                </div>
                <button type="submit"
                    disabled={submitting}
                    className="rg-login-btn-signin">{t('auth.button.sendLoginLink')}</button>
            </form>
            <div className="rg-login-row-between" style={{ justifyContent: 'center', margin: '18px 0 0' }}>
                <Link to="/Login" className="rg-login-link">{t('common.button.back')}</Link>
            </div>
        </AuthShell>
    )
}

const mapDispatch = dispatch => ({
    AlertError: message => dispatch(AlertAction.Error(message)),
})

export default connect(null, mapDispatch)(ForgotPassword);